/**
 * Validates if a string is a properly formatted email address
 *
 * @param email The email string to validate
 * @returns boolean indicating if the email is valid
 */
export const isValidEmail = (email) => {
    if (typeof email !== 'string' || email.trim() === '') {
        return false;
    }
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
        return false;
    }
    const [localPart, domain] = email.split('@');
    if (localPart.includes('..')) {
        return false;
    }
    if (domain.includes('..')) {
        return false;
    }
    const domainParts = domain.split('.');
    const hasInvalidPart = domainParts.some((part) => part.startsWith('-') || part.endsWith('-') || part.length === 0);
    if (hasInvalidPart) {
        return false;
    }
    const topLevelDomain = domainParts[domainParts.length - 1];
    if (topLevelDomain.length < 2 || topLevelDomain.length > 24) {
        return false;
    }
    return true;
};
//# sourceMappingURL=isValidEmail.js.map